exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".service-table-container[data-v-332e6b32] {\n  max-height: 600px;\n}\n.service-table-container.with-scroll[data-v-332e6b32] {\n  overflow-y: scroll;\n}\n.service-totals-container.with-scroll[data-v-332e6b32] {\n  padding-right: 15px;\n}\n.custom-badge.inventory-status[data-v-332e6b32] {\n  max-width: 100%;\n}\n.service-count-column[data-v-332e6b32] {\n  text-align: right;\n  padding-right: 50px;\n}\n.volume-column[data-v-332e6b32] {\n  width: 60px;\n}\n.width-column[data-v-332e6b32] {\n  width: 60px;\n}\n.actions-column[data-v-332e6b32] {\n  width: 100px;\n}\n.icon-style[data-v-332e6b32] {\n  color: white;\n}\n", ""]);

// exports
